import React, { Component } from 'react';
import { browserHistory } from 'react-router';

import InputButton from './../../../../../components/ZUILib/InputButton';

import commonUtil from '../../../../../utils/commonUtil';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();

class NotAvailableGifthTable extends Component {
  constructor(props) {
    super(props);
    this.labels = this.props.labels;
  }

  backToHome = () => {
    browserHistory.push(commonUtil.getRouteByParameter('/'));
  }

  render() {
    const gifthBrand = ({
      PB: commonUtil.getLabel(this.labels.EventAdminPage, 'adminpage.button.goto.pb'),
      PBK: commonUtil.getLabel(this.labels.EventAdminPage, 'adminpage.button.goto.pbk'),
      GAP: commonUtil.getLabel(this.labels.EventAdminPage, 'adminpage.button.goto.gap'), // TODO: don't exist label
      WLM: commonUtil.getLabel(this.labels.EventAdminPage, 'adminpage.button.goto.wlm'),
      WS: commonUtil.getLabel(this.labels.EventAdminPage, 'adminpage.button.goto.ws'),
      TRU: commonUtil.getLabel(this.labels.EventAdminPage, 'adminpage.button.goto.tru'), // TODO: don't exist label
    });

    const goToHomePageButton = commonUtil.getLabel(this.labels.EventAdminPage, 'adminpage.button.goto.lp');

    const redirectToHomePageButton = {
      value: gifthBrand[commonUtil.getBrand()] || goToHomePageButton,
      style: constChannels.WEB ? 'btnPrimary size-ExtraLarge' : 'btnPrimary size-Full',
      onClickHandler: this.backToHome,
    };

    return (
      <div className="container wrapCLP">
        <div className="row headerCLP">
          <div className="col-md-8 col-md-offset-2 text-center">
            <h3 className={channel === constChannels.WEB ? '' : 'col-md-8 col-md-offset-2 text-left'}>
              {this.labels ? commonUtil.getLabel(this.labels.GuestviewPage, 'guestview.event.not.available.message') : 'la mesa de regalos que estás buscando no está disponible'}
            </h3>
            <p className={channel === constChannels.WEB ? '' : 'col-md-8 col-md-offset-2 text-left'}>
              {this.labels ? commonUtil.getLabel(this.labels.GuestviewPage, 'guestview.event.not.available.message1') : 'la mesa a la cual estás tratando de ingresar no está disponible'}
            </p>
            <InputButton buttonAttr={redirectToHomePageButton} />
          </div>
        </div>
      </div>
    );
  }
}

export default NotAvailableGifthTable;
